import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { BaseToastService } from '@shared/layout/services/base-toast.service';
import { BASE_HREF } from '@envs/base-urls';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BaseService {
  /* 
    Por cuestiones de tiempo; queda pendiente, store de cada service. Para mejorar performance.
  */
  
  protected readonly _http: HttpClient = inject( HttpClient );
  protected readonly _router: Router = inject( Router );

  protected readonly baseToastSvc: BaseToastService  = inject( BaseToastService );


  protected requestWithCorrelation<T>( method: 'PUT' | 'DELETE', url: string, correlation_id: string, body?: any ): Observable<T> {
    const headers: HttpHeaders = new HttpHeaders( { 'Correlation-Id': correlation_id } );
    const options = { headers };
  
    if (method === 'PUT') return this._http.put<T>( url, body, options );
    if (method === 'DELETE') return this._http.delete<T>( url, options );
    
    throw new Error( 'Unsupported HTTP method' );
  }

  protected requestGetWithParams<T>(
    url: string,
    params: { [key: string]: any },
    headers?: Record<string, string>
  ): Observable<T> {
    let httpParams: HttpParams = new HttpParams();

    for (const key in params) {
      const value = params[ key ];
      httpParams = httpParams.set( key, String( value ) );
    }
  
    return this._http.get<T>( url, { params: httpParams, headers } );
  }

  public goToCustomUrlGlobal( path: string ) {
    this._router.navigate( [ `${BASE_HREF}${path}` ] );
  }
}